export const thunkMiddleware = store => next => action => {
    if (typeof action === "function") {
        return action(store, next);
    }
    return next(action);
}  